/**
 * Root App component — wires together providers, router, and AppShell.
 *
 * Provider hierarchy:
 * 1. QueryProvider (TanStack Query)
 * 2. RouterProvider (TanStack Router)
 * 3. AppShell wraps the route outlet
 */

import { Suspense } from 'react';
import { RouterProvider } from '@tanstack/react-router';

import { QueryProvider } from './providers/QueryProvider';
import { AuthProvider } from './providers/AuthProvider';
import { router } from './router';
import './i18n';

function Loading() {
  return <div data-testid="loading-fallback">Carregando...</div>;
}

export function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <Suspense fallback={<Loading />}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </QueryProvider>
  );
}
